<template>
  <div>
    <!--    <div class="row mb-3">-->
    <!--      <div class="col">-->
    <!--        <h5>Filter by type:</h5>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="row mb-3">-->
    <!--      <div class="col">-->
    <!--        <div class="btn-group" role="group" aria-label="Basic radio toggle button group">-->
    <!--          <input type="radio" class="btn-check" name="selectedType" id="btnradio1" :value="null" autocomplete="off"-->
    <!--                 v-model="selectedTypeComp">-->
    <!--          <label class="btn btn-outline-primary" for="btnradio1">None</label>-->

    <!--          <input type="radio" class="btn-check" name="selectedType" id="btnradio2" value="1" autocomplete="off"-->
    <!--                 v-model="selectedTypeComp">-->
    <!--          <label class="btn btn-outline-primary" for="btnradio2">Abstract</label>-->

    <!--          <input type="radio" class="btn-check" name="selectedType" id="btnradio3" value="2" autocomplete="off"-->
    <!--                 v-model="selectedTypeComp">-->
    <!--          <label class="btn btn-outline-primary" for="btnradio3">Clinical Case</label>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="row mb-3">
      <div class="col">
        <h5>Select by topic:</h5>
      </div>
    </div>

    <template v-if="hasSecondLevelThemes">
      <div class="row row-cols-1 row-cols-md-5 g-4 h-100">
        <template v-for="parent in themes">
          <div class="col" v-if="parent.poster_count > 0">
            <button class="btn d-inline-flex w-100 position-relative"
                    v-bind:class="parent.id === selectedParent ?'btn-success' : 'btn-outline-primary'"
                    v-on:click="selectedParent = parent.id; selectedMiddle = null; selectedThemeComp = null;">
              <div class="my-auto mx-auto">{{ parent.label }}</div>
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
          {{ parent.poster_count }}
          <span class="visually-hidden">uploaded poster</span>
          </span>
            </button>
          </div>
        </template>
      </div>
      <div class="row row-cols-1 row-cols-md-5 g-4 h-100 mt-3" v-if="selectedParent">
        <template v-for="middle in themes.find(theme => theme.id === selectedParent).children">
          <div class="col" v-if="middle.poster_count > 0">
            <button class="btn  w-100 h-100 position-relative"
                    v-bind:class="middle.id === selectedMiddle ?'btn-success' : 'btn-secondary'"
                    v-on:click="selectedMiddle = middle.id; selectedThemeComp = null;">
              {{ middle.label }}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
          {{ middle.poster_count }}
          <span class="visually-hidden">uploaded poster</span>
          </span>
            </button>
          </div>
        </template>
      </div>
      <div class="row row-cols-1 row-cols-md-6 g-4 h-100 mt-3" v-if="selectedMiddle">
        <template
            v-for="themeItem in themes.find(theme => theme.id === selectedParent).children.find(child => child.id === selectedMiddle).children">
          <div class="col" v-if="themeItem.poster_count > 0">
            <button class="btn  w-100 h-100 position-relative"
                    v-bind:class="themeItem.id === selectedThemeComp ?'btn-success' : 'btn-outline-primary'"
                    v-on:click="selectTheme(themeItem.id)" data-bs-dismiss="offcanvas">
              {{ themeItem.label }}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
          {{ themeItem.poster_count }}
          <span class="visually-hidden">uploaded poster</span>
          </span>
            </button>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-4 h-100 mt-3">
        <template
            v-for="themeItem in themes">
          <div class="col" v-if="themeItem.poster_count > 0">
            <button class="btn  w-100 h-100 position-relative"
                    v-bind:class="themeItem.id === selectedThemeComp ?'btn-success' : 'btn-outline-primary'"
                    v-on:click="selectTheme(themeItem.id)" data-bs-dismiss="offcanvas">
              {{ themeItem.label }}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
          {{ themeItem.poster_count }}
          <span class="visually-hidden">uploaded poster</span>
          </span>
            </button>
          </div>
        </template>
      </div>
    </template>

  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: "GroupSelectionThemes",
  data: function () {
    return {
      // selectedParent: null,
      // selectedMiddle: null,
      // selectedTheme: null
    }
  },
  computed: {
    ...mapState(['themes', 'selectedType']),
    ...mapState('theme', ['firstLevelTheme', 'secondLevelTheme', 'selectedTheme']),
    selectedParent: {
      get() {
        return this.firstLevelTheme
      },
      set(id) {
        this.setFirstLevelTheme(id);
      }
    },
    selectedMiddle: {
      get() {
        return this.secondLevelTheme
      },
      set(id) {
        this.setSecondLevelTheme(id);
      }
    },
    selectedThemeComp: {
      get() {
        return this.selectedTheme
      },
      set(id) {
        this.setSelectedTheme(id);
      }
    },
    selectedTypeComp: {
      get() {
        return this.selectedType
      },
      set(id) {
        this.setSelectedType(id);
      }
    },
    hasSecondLevelThemes: {
      get() {
        this.themes.forEach((element) => {
          if (element.children && element.children.length > 0) {
            return true
          }
        });
        return false;
      },
    }
  },
  methods: {
    ...mapMutations(['setSelectedView', 'setSelectedType']),
    ...mapMutations('theme', ['setFirstLevelTheme', 'setSecondLevelTheme', 'setSelectedTheme']),
    selectTheme(theme_id) {
      this.selectedThemeComp = theme_id;
      this.$store.dispatch('TRACK_ACTION', {
        'value': theme_id,
        'action': 'view/theme',
        'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
      });
      this.setSelectedView('theme');
      this.$emit('push');
    }
  }
}
</script>

<style scoped>

</style>
